import { computed } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { CONTENT_FEED_SORTS } from "@/const";

export const sortFields = computed(() => [
  {
    title: $t("Newest Posts"),
    slug: "newest",
    sort: CONTENT_FEED_SORTS.NEWEST,
  },
  {
    title: $t("Oldest Posts"),
    slug: "oldest",
    sort: CONTENT_FEED_SORTS.OLDEST,
  },
  {
    title: $t("Random Posts"),
    slug: "random",
    sort: CONTENT_FEED_SORTS.RANDOM,
  },
]);
